import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "react-bootstrap/Button";
import apiClient from "../Login/apiClient";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons";

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
  padding: 0 16px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-top: 20px;
    padding: 0 8px;
  }
`;

const StyleLeftAlignedContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 8px;
  }
`;

const StyledButton = styled(Button)`
  width: 250px;
  height: 40px;
  font-size: 20px;
  margin-left: 3px;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
    font-size: 18px;
  }
`;

const SupportStyledButton = styled.button`
  border: 1.5px solid #000;
  border-radius: 8px;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 10px;
  color: black;
  margin-left: 3px;
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 8px 12px;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 10px 16px;
    flex: 1;
    margin-left: 0;
  }
`;

const ReactionCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  margin-left: 4px;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  background: ${(props) => props.$tone === "support" ? "#e7f4ff" : "#ffe8e8"};
  color: ${(props) => props.$tone === "support" ? "#1d5f91" : "#a73d3d"};
  border: 1px solid ${(props) => props.$tone === "support" ? "#b9daf4" : "#f0b9b9"};
`;

const StyledTextArea = styled.textarea`
  height: 280px;
  width: 100%;
  max-width: 500px;
  margin-top: 20px;
  outline: none;
  box-sizing: border-box;
  font-size: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const CommentForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  min-width: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 8px;
  }
`;

// ========== 無謀度AI分析 & カード表示 ==========

const SHARE_API_URL = process.env.REACT_APP_SHARE_API_URL || "";

// ========== styled-components ==========

const ShareButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 15px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid;
  margin-top: 12px;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
    text-decoration: none;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 14px;
    width: 90%;
    justify-content: center;
  }
`;

const CardImageContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 4px auto 16px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
  &:hover { transform: scale(1.02); }

  @media (max-width: 768px) {
    max-width: 95%;
    margin: 12px auto;
    border-radius: 12px;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const CardImageSkeleton = styled.div`
  width: 100%;
  aspect-ratio: 1200 / 630;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 16px;
  font-weight: bold;

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

const LoadingPulse = styled.div`
  @keyframes pulse {
    0%, 100% { opacity: 0.4; }
    50% { opacity: 1; }
  }
  animation: pulse 1.5s ease-in-out infinite;
  font-size: 18px;
  font-weight: bold;
  padding: 30px;
  text-align: center;
  white-space: pre-line;
`;

const ShareButtonRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 12px;
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    max-width: 95%;
  }
`;

const SmallShareButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  color: #fff;
  white-space: nowrap;
  box-sizing: border-box;
  min-height: 44px;
  -webkit-appearance: none;
  appearance: none;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 14px 20px;
    font-size: 15px;
  }
`;

const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid #666;
  background: transparent;
  color: #666;
  white-space: nowrap;
  box-sizing: border-box;
  max-width: 100%;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    background: #f0f0f0;
  }

  @media (max-width: 768px) {
    width: 80%;
    justify-content: center;
    font-size: 12px;
    padding: 10px 16px;
  }
`;

const LoginPrompt = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 16px 24px;
  margin: 12px 0;
  text-align: center;
  color: #fff;
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 12px 12px;
    margin: 8px 0;
    max-width: 95%;
  }
`;

const LoginPromptButton = styled.button`
  padding: 8px 20px;
  border-radius: 50px;
  border: 2px solid #fff;
  background: transparent;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  margin: 4px 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
  &:hover {
    background: #fff;
    color: #764ba2;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
    margin: 4px 4px;
  }
`;

const LikeButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 12px;
  transition: all 0.2s ease;
  color: ${props => props.$liked ? '#e53e3e' : '#999'};
  &:hover {
    background: #fee2e2;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
`;

const ProgressSection = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 20px auto;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 12px;
  }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 20px;
  background: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  margin: 8px 0;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${props => props.$percent}%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 10px;
  transition: width 0.5s ease;
`;

const ProgressInput = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const OwnerSettingCard = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 8px auto 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff8e8;
  border: 1px solid #f3d7a6;
  box-sizing: border-box;
`;

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const ToggleButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  color: #fff;
  background: ${(props) => (props.$enabled ? "#2f855a" : "#718096")};
  min-width: 82px;
`;

const NextStepCard = styled.div`
  width: 100%;
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff7ed 0%, #eefdf3 100%);
  border: 1px solid #fed7aa;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
  box-sizing: border-box;
`;

const NextStepTitle = styled.div`
  color: #7c2d12;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.02em;
`;

const NextStepLead = styled.p`
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.6;
`;

const NextStepList = styled.ul`
  margin: 10px 0 0;
  padding-left: 18px;
  color: #2f3a2f;
  font-size: 13px;
  line-height: 1.7;
`;

const NextStepItem = styled.li`
  margin: 4px 0;
`;
const JourneySummaryDetails = styled.details`
  width: 100%;
  margin-top: 14px;
  background: #fff;
  border: 1px solid #e3e6ea;
  border-radius: 12px;
  overflow: hidden;
`;

const JourneySummaryToggle = styled.summary`
  cursor: pointer;
  list-style: none;
  padding: 14px 16px;
  font-weight: bold;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  &::-webkit-details-marker {
    display: none;
  }
`;

const JourneySummaryBody = styled.div`
  padding: 0 16px 16px;
  border-top: 1px solid #eef1f4;
`;

const JourneyHeadline = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #222;
  line-height: 1.6;
  margin-top: 14px;
`;

const JourneyMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const JourneyBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: bold;
  background: #f1f3f5;
  color: #4a5568;
`;

const JourneyList = styled.ul`
  margin: 12px 0 0;
  padding-left: 18px;
  color: #444;
  font-size: 13px;
  line-height: 1.7;
`;

const JourneyFooter = styled.div`
  margin-top: 12px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.6;
`;

const ReturnHint = styled.div`
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8f7ff;
  border: 1px solid #ded9ff;
  color: #58539a;
  font-size: 12px;
  line-height: 1.7;
`;

const CommentItem = styled.li`
  margin-bottom: 16px;
  padding: 14px 14px 12px;
  border-bottom: 1px solid #eee;
  border-radius: 14px;
  background: ${({ $isOwnerComment }) => ($isOwnerComment ? "#fff6d8" : "#ffffff")};
  border: 1px solid ${({ $isOwnerComment }) => ($isOwnerComment ? "#f0d37a" : "#eeeeee")};
  box-shadow: ${({ $isOwnerComment }) =>
    $isOwnerComment ? "0 6px 18px rgba(156, 117, 29, 0.08)" : "none"};
`;

const CommentMetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
  font-weight: 600;
`;

const CommentBody = styled.div`
  font-size: 15px;
  line-height: 1.7;
  white-space: pre-wrap;
  color: ${({ $isOwnerComment }) => ($isOwnerComment ? "#5b4600" : "#333")};
`;

const CommentActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
`;

const OwnerCommentBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #ffdf72;
  color: #6b4b00;
  font-size: 11px;
  font-weight: 800;
`;

const PrivacyHint = styled.div`
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.7;
`;

const AiResidentBadge = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #fff3c4;
  border: 1px solid #efd37a;
  color: #7a4f00;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  vertical-align: middle;
`;

const DeleteCommentButton = styled.button`
  border: 1px solid #d8d8d8;
  background: #fafafa;
  color: #666;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 7px 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fff1f1;
    border-color: #f0b7b7;
    color: #b42318;
  }
`;

const AiGuideLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  margin: 0 0 10px;
  color: #7a4b00;
  font-size: 13px;
  font-weight: 800;
  text-decoration: underline;

  &:hover {
    color: #4c2e00;
  }
`;

// ========================================

const buildJourneySummary = ({ goal, board, progresses, comments, supportCount, noWayCount }) => {
  if (!goal || !board) return null;

  const latestProgress = progresses.length > 0 ? progresses[0].percentage : 0;
  const progressReports = progresses.length;
  const humanComments = comments.filter((comment) => !comment.is_ai_generated);
  const aiComments = comments.filter((comment) => comment.is_ai_generated);
  const totalComments = comments.length;
  const latestNote = progresses[0]?.note?.trim() || "";
  const latestHumanComment = humanComments[0]?.comment_text?.trim() || "";
  const totalReactions = supportCount + noWayCount;
  const supportRatio = totalReactions > 0 ? supportCount / totalReactions : 0;
  const badges = [];
  const facts = [];
  let headline = "";

  if (latestProgress >= 80) {
    badges.push("かなり前進");
  } else if (latestProgress >= 40) {
    badges.push("じわじわ前進");
  } else if (progressReports > 0) {
    badges.push("まだ助走");
  } else {
    badges.push("構想段階");
  }

  if (supportCount > noWayCount) {
    badges.push("応援優勢");
  } else if (noWayCount > supportCount) {
    badges.push("反骨心の燃料あり");
  } else if (totalReactions > 0) {
    badges.push("反応あり");
  }

  if (humanComments.length >= 5) {
    badges.push("人が集まってる");
  } else if (humanComments.length > 0) {
    badges.push("会話が発生中");
  } else {
    badges.push("まだ静か");
  }

  if (latestProgress >= 70 && supportRatio >= 0.6) {
    headline = `${goal.title} は、最初の無茶さを少しずつ実績で黙らせ始めています。`;
  } else if (latestProgress === 0 && totalComments >= 8) {
    headline = `${goal.title} は、掲示板の熱量が先に走っていて、進捗だけまだ置いてきぼりです。`;
  } else if (progressReports >= 3 && latestProgress < 30) {
    headline = `${goal.title} は、少しずつ報告が積み重なっています。次に試せそうなことを一つ選んでみましょう。`;
  } else if (noWayCount >= supportCount + 3) {
    headline = `${goal.title} には「できるわけないよ！」の声も届いています。小さな一歩を重ねて、達成したときに見返しましょう。`;
  } else if (supportCount >= noWayCount + 3) {
    headline = `${goal.title} は、思ったより味方が多い流れです。ここで本当に進むと一気に説得力が出ます。`;
  } else {
    headline = `${goal.title} は、まだ評価が固まりきっていないぶん、これからの一歩で空気が変わりそうです。`;
  }

  facts.push(`進捗報告は ${progressReports} 回、現在の達成進捗は ${latestProgress}% です。`);

  if (latestNote) {
    facts.push(`最新メモは「${latestNote}」。ここが今の物語のいちばん新しい断面です。`);
  } else if (progressReports > 0) {
    facts.push("進捗は更新されていますが、最新メモは短めです。次は一言あるだけで流れがもっと見えます。");
  } else {
    facts.push("まだ進捗メモがないので、物語はほぼプロローグです。");
  }

  if (totalReactions > 0) {
    facts.push(`反応は 応援 ${supportCount} / できるわけないよ！ ${noWayCount} です。`);
  } else {
    facts.push("最初の応援やコメントを待っています。");
  }

  if (humanComments.length > 0) {
    facts.push(`人のコメントは ${humanComments.length} 件、AIコメントは ${aiComments.length} 件。掲示板は${humanComments.length >= 3 ? "ちゃんと会話の形" : "まだ呼び込み中"}です。`);
  } else if (aiComments.length > 0) {
    facts.push(`今はAIが場を温めている段階で、コメント総数は ${totalComments} 件です。`);
  } else {
    facts.push("まだ掲示板は静かで、最初の観客待ちです。");
  }

  if (latestHumanComment) {
    facts.push(`直近の人間コメントは「${latestHumanComment}」でした。ここが次の流れの起点になりそうです。`);
  }

  return {
    headline,
    badges,
    facts,
    footer: latestProgress >= 100
      ? "ここまで来たら、もう無謀というより成果です。"
      : "次の一歩が入るたびに、この要約も少しずつ育っていきます。",
  };
};

const summaryKeywordGroups = {
  uncertainty: ["不安", "無理", "厳しい", "きつい", "迷う", "しんど", "やばい"],
  planning: ["どう", "何", "どこ", "いつ", "方法", "手順", "次", "まず", "戦略", "計画", "相談", "教えて"],
  progress: ["進捗", "できた", "進んだ", "やった", "終わった", "報告", "完成", "達成"],
  cheering: ["応援", "いいね", "好き", "期待", "見たい", "すごい", "がんば"],
  teasing: ["草", "笑", "w", "やば", "ほんと", "無茶", "むずい"],
};

const countKeywordHits = (texts, keywords) =>
  texts.reduce(
    (count, text) => (keywords.some((keyword) => text.includes(keyword)) ? count + 1 : count),
    0
  );

const buildFlowSummary = (humanComments) => {
  const recentTexts = humanComments
    .slice(0, 6)
    .map((comment) => (comment.comment_text || "").trim())
    .filter(Boolean);

  if (recentTexts.length === 0) {
    return {
      theme: "まだ大きな流れは生まれていません。",
      tone: "掲示板はまだ静かです。",
      sample: "",
    };
  }

  const uncertaintyHits = countKeywordHits(recentTexts, summaryKeywordGroups.uncertainty);
  const planningHits = countKeywordHits(recentTexts, summaryKeywordGroups.planning);
  const progressHits = countKeywordHits(recentTexts, summaryKeywordGroups.progress);
  const cheeringHits = countKeywordHits(recentTexts, summaryKeywordGroups.cheering);
  const teasingHits = countKeywordHits(recentTexts, summaryKeywordGroups.teasing);

  let theme = "夢の輪郭を探る雑談が続いています。";
  if (progressHits >= 2) {
    theme = "最近の流れは、進捗報告を起点に前へ進める空気です。";
  } else if (planningHits >= 2) {
    theme = "最近の流れは、どう進めるかを詰める作戦会議寄りです。";
  } else if (uncertaintyHits >= 2) {
    theme = "最近の流れは、不安や難しさをどう越えるかに寄っています。";
  } else if (cheeringHits >= 2) {
    theme = "最近の流れは、背中を押す応援ムードが強めです。";
  } else if (teasingHits >= 2) {
    theme = "最近の流れは、少し茶化しつつも気にして見ている感じです。";
  }

  let tone = "空気はまだ定まりきっていません。";
  if (cheeringHits > teasingHits && cheeringHits >= uncertaintyHits) {
    tone = "全体としては前向きで、見守る側も乗りやすい空気です。";
  } else if (uncertaintyHits > cheeringHits) {
    tone = "少し弱気な場面も見えるので、次の一歩があると空気が変わりそうです。";
  } else if (teasingHits >= 2) {
    tone = "軽いツッコミが混ざっていて、掲示板らしい温度はちゃんとあります。";
  }

  return {
    theme,
    tone,
    sample: recentTexts[0],
  };
};

const buildNextStepSuggestions = ({ progresses, comments, supportCount, noWayCount, latestProgress }) => {
  const humanComments = comments.filter((comment) => !comment.is_ai_generated);
  const latestNote = progresses[0]?.note?.trim() || "";
  const suggestions = [];

  if (progresses.length === 0) {
    suggestions.push("まずは『今どこまでできているか』を一言でコメントしてみよう。");
    suggestions.push("最初の7日でできる一番小さい行動を1つ決めよう。");
  } else if (latestNote.length < 8) {
    suggestions.push("最新の進捗に、次に試すことを1つだけ足してみよう。");
  } else {
    suggestions.push("次の報告で『何が進んだか』と『何に詰まったか』を1つずつ書こう。");
  }

  if (humanComments.length === 0) {
    suggestions.push("掲示板で『何から始めるとよさそう？』と聞いてみよう。");
  } else if (latestProgress < 30) {
    suggestions.push("完璧な成果より、次の小さな実験を1つ報告しよう。");
  } else if (latestProgress < 70) {
    suggestions.push("ここまで進んだ理由を1つ書くと、応援する人が乗りやすい。");
  } else {
    suggestions.push("達成条件をもう一度言葉にして、最後の詰めを見える形にしよう。");
  }

  if (supportCount > noWayCount) {
    suggestions.push("応援があるうちに、次の報告日を決めてみよう。");
  } else if (noWayCount > supportCount) {
    suggestions.push("「できるわけないよ！」を燃料に、今日できる小さな一歩を一つ残そう。");
  } else {
    suggestions.push("今日やることを小さく書くと、この夢が少し現実側に寄ります。");
  }

  return [...new Set(suggestions)].slice(0, 3);
};
const buildCommentAwareJourneySummary = (params) => {
  const baseSummary = buildJourneySummary(params);
  if (!baseSummary) return null;

  const humanComments = params.comments.filter((comment) => !comment.is_ai_generated);
  const aiComments = params.comments.filter((comment) => comment.is_ai_generated);
  const flowSummary = buildFlowSummary(humanComments);
  const facts = [...baseSummary.facts];

  if (humanComments.length > 0) {
    facts.splice(
      2,
      0,
      `最近のコメントの流れは「${flowSummary.theme}」で、${flowSummary.tone}`
    );
    if (flowSummary.sample) {
      facts.push(`直近の人間コメントは「${flowSummary.sample}」でした。ここが次の流れの起点になりそうです。`);
    }
    facts.push(
      `人のコメントは ${humanComments.length} 件、AIコメントは ${aiComments.length} 件。掲示板は${
        humanComments.length >= 3 ? "ちゃんと会話の形" : "まだ呼び込み中"
      }です。`
    );
  }

  return {
    ...baseSummary,
    headline: params.goal?.journey_summary || `${baseSummary.headline} ${flowSummary.theme}`,
    facts,
    footer: "コメントの流れが変わるたびに、この要約も少しずつ育っていきます。",
  };
};

const SENSITIVE_COMMENT_PATTERNS = [
  /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i,
  /https?:\/\/[^\s]+/i,
  /(?:^|[^\d])(?:\+?81[-\s]?)?(?:0\d{1,4}[-\s]?\d{1,4}[-\s]?\d{3,4})(?:$|[^\d])/,
  /(?:^|[^\d])\d{10,11}(?:$|[^\d])/,
  /\b\d{3}-\d{4}\b/,
];

const hasSensitiveInfo = (text) =>
  SENSITIVE_COMMENT_PATTERNS.some((pattern) => pattern.test(text || ""));

function BoardDetailPage() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const accessToken = localStorage.getItem("accessToken");
  const COMMENT_PER_PAGE = 200;
  const navigate = useNavigate();

  const [goal, setGoal] = useState(null);
  const [noWayCount, setNoWayCount] = useState(0);
  const [supportCount, setSupportCount] = useState(0);
  const [board, setBoard] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [aiAnalysis, setAiAnalysis] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiRefreshTick, setAiRefreshTick] = useState(0);
  const [cardImageRetryTick, setCardImageRetryTick] = useState(0);
  const [cardImageFailed, setCardImageFailed] = useState(false);
  const [cardImageLoaded, setCardImageLoaded] = useState(false);
  const [showCardImageLoading, setShowCardImageLoading] = useState(false);
  const [progresses, setProgresses] = useState([]);
  const [newProgress, setNewProgress] = useState({ percentage: 0, note: "" });
  const [achievementForm, setAchievementForm] = useState({
    report: "",
    verification_requested: false,
    verification_note: "",
  });
  const [achievementSaving, setAchievementSaving] = useState(false);
  const [noWayPressed, setNoWayPressed] = useState(false);
  const [likedCommentIds, setLikedCommentIds] = useState({}); // {commentId: true/false}
  const likeProcessing = useRef(false);
  const likeCooldownRef = useRef({}); // {commentId: timestamp} 連打防止用
  const [commentCooldown, setCommentCooldown] = useState(0); // 連投防止クールダウン（秒）
  const [commentSubmitting, setCommentSubmitting] = useState(false);
  const [aiCommentsSaving, setAiCommentsSaving] = useState(false);
  const cooldownTimer = useRef(null);
  const { id } = useParams();
  useEffect(() => {
    setUnavailable(false);
    setGoal(null);
    setBoard(null);
  }, [id]);
  const currentUserID = parseInt(JSON.parse(localStorage.getItem("user"))?.id, 10);
  const isLoggedIn = !!accessToken;
  const commentHasSensitiveInfo = hasSensitiveInfo(newComment);

  const normalizeComments = useCallback((items, ownerId = null) => (
    items.map((comment) => ({
      ...comment,
      user_name: comment.user_name || "何者でもない小市民",
      is_owner_comment:
        ownerId != null &&
        comment.created_by != null &&
        parseInt(comment.created_by, 10) === parseInt(ownerId, 10),
    }))
  ), []);

  // AI無謀度分析を取得
  useEffect(() => {
    if (!id || !SHARE_API_URL) return;

    let isCancelled = false;
    let retryCount = 0;
    let timerId = null;

    const fetchAiResult = async () => {
      setAiLoading(true);
      try {
        const res = await axios.get(`${SHARE_API_URL}/api/result/${id}`);
        if (!isCancelled) {
          setAiAnalysis(res.data);
        }
      } catch (err) {
        if (!isCancelled && retryCount < 6) {
          retryCount += 1;
          timerId = window.setTimeout(fetchAiResult, 1800);
        } else {
          console.log("AI result not ready:", err);
        }
      } finally {
        if (!isCancelled) {
          setAiLoading(false);
        }
      }
    };

    fetchAiResult();

    return () => {
      isCancelled = true;
      if (timerId) window.clearTimeout(timerId);
    };
  }, [id, aiRefreshTick]);

  useEffect(() => {
    if (cardImageLoaded) {
      setShowCardImageLoading(false);
      return undefined;
    }
    setShowCardImageLoading(false);
    const timerId = window.setTimeout(() => {
      setShowCardImageLoading(true);
    }, 700);
    return () => window.clearTimeout(timerId);
  }, [id, cardImageRetryTick, cardImageLoaded]);

  useEffect(() => {
    setAiRefreshTick(0);
    setCardImageRetryTick(0);
    setCardImageFailed(false);
    setCardImageLoaded(false);
  }, [id]);

  // 進捗データを取得
  const fetchProgress = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/goals/${id}/progress/`);
      setProgresses(res.data);
    } catch (err) {
      console.log("Progress fetch failed:", err);
    }
  }, [id, API_BASE_URL]);

  useEffect(() => {
    fetchProgress();
  }, [fetchProgress]);

  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastComment = currentPage * COMMENT_PER_PAGE;
  const indexOfFirstComment = indexOfLastComment - COMMENT_PER_PAGE;
  const currentComments = comments.slice(indexOfFirstComment, indexOfLastComment);
  const totalPages = Math.ceil(comments.length / COMMENT_PER_PAGE);

  const StyledList = styled.ol`
    list-style-type: decimal;
    padding-left: 30px;
    margin-top: 10px;
  `;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchGoalAndComments = useCallback(async () => {
    try {
      const client = isLoggedIn ? apiClient : axios;
      const goalResponse = await client.get(`${API_BASE_URL}/api/goals/${id}/`);
      setGoal(goalResponse.data);
      setSupportCount(goalResponse.data.support_count);
      setNoWayCount(goalResponse.data.no_way_count);

      const commentsResponse = await client.get(`${API_BASE_URL}/api/boards/${id}/comments/`);
      setComments(normalizeComments(commentsResponse.data, goalResponse.data?.user));
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 404) {
        setUnavailable(true);
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  }, [id, isLoggedIn, API_BASE_URL, normalizeComments]);

  useEffect(() => {
    fetchGoalAndComments();
  }, [fetchGoalAndComments]);

  const fetchBoardAndComments = useCallback(async () => {
    try {
      const client = isLoggedIn ? apiClient : axios;
      const boardResponse = await client.get(`${API_BASE_URL}/api/boards/${id}/`);
      setBoard(boardResponse.data);

      const commentsResponse = await client.get(`${API_BASE_URL}/api/boards/${id}/comments/`);
      setComments(normalizeComments(commentsResponse.data, boardResponse.data?.created_by?.id));
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 404) {
        setUnavailable(true);
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  }, [id, isLoggedIn, API_BASE_URL, normalizeComments]);

  useEffect(() => {
    fetchBoardAndComments();
  }, [fetchBoardAndComments]);

  useEffect(() => {
    if (!id || unavailable || !SHARE_API_URL || goal?.ai_score) return undefined;

    let cancelled = false;
    let timerId = null;
    let retryCount = 0;

    const pollForGeneratedAssets = async () => {
      if (cancelled) return;
      retryCount += 1;
      await fetchGoalAndComments();
      if (cancelled) return;
      setAiRefreshTick((prev) => prev + 1);
      setCardImageRetryTick((prev) => prev + 1);
      if (retryCount < 8) {
        timerId = window.setTimeout(pollForGeneratedAssets, 2500);
      }
    };

    timerId = window.setTimeout(pollForGeneratedAssets, 1800);
    return () => {
      cancelled = true;
      if (timerId) window.clearTimeout(timerId);
    };
  }, [id, unavailable, SHARE_API_URL, goal?.ai_score, fetchGoalAndComments]);

  useEffect(() => {
    if (!id || unavailable) return undefined;

    const intervalId = window.setInterval(() => {
      if (document.visibilityState === "visible") {
        fetchBoardAndComments();
      }
    }, 3000);

    return () => window.clearInterval(intervalId);
  }, [id, unavailable, fetchBoardAndComments]);

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (commentSubmitting) return;
    const trimmedComment = newComment.trim();
    if (commentCooldown > 0) {
      toast.info(`連投防止: あと${commentCooldown}秒お待ちください`);
      return;
    }
    if (!trimmedComment) {
      toast.info("コメントを入力してください");
      return;
    }
    if (hasSensitiveInfo(trimmedComment)) {
      toast.warn("メールアドレス・電話番号・URLなど、個人情報っぽい内容は掲示板に書かないでください");
      return;
    }
    setCommentSubmitting(true);
    const commentClient = isLoggedIn ? apiClient : axios;
    try {
      await commentClient.post(
        `${API_BASE_URL}/api/boards/${id}/comments/`,
        { comment_text: trimmedComment, board: id }
      );
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setNewComment("");
      fetchBoardAndComments();
      toast.success("コメントを投稿しました。少ししたら返事が増えるかも。");
      // 投稿成功後30秒クールダウン
      setCommentCooldown(15);
      if (cooldownTimer.current) clearInterval(cooldownTimer.current);
      cooldownTimer.current = setInterval(() => {
        setCommentCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(cooldownTimer.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 429) {
        toast.warn("連投防止: しばらくお待ちください。");
        setCommentCooldown(15);
        if (cooldownTimer.current) clearInterval(cooldownTimer.current);
        cooldownTimer.current = setInterval(() => {
          setCommentCooldown((prev) => {
            if (prev <= 1) { clearInterval(cooldownTimer.current); return 0; }
            return prev - 1;
          });
        }, 1000);
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    } finally {
      setCommentSubmitting(false);
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      await apiClient.delete(`${API_BASE_URL}/api/boards/${id}/comments/${commentId}/`);
      fetchBoardAndComments();
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  };

  const handleToggleAiComments = async () => {
    if (!isOwner || aiCommentsSaving || !board) return;
    setAiCommentsSaving(true);
    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/api/boards/${id}/toggle_ai_comments/`,
        { enabled: !board.ai_comments_enabled }
      );
      setBoard((prev) => (
        prev
          ? { ...prev, ai_comments_enabled: response.data.ai_comments_enabled }
          : prev
      ));
      toast.success(
        response.data.ai_comments_enabled
          ? "AIコメントをONにしました"
          : "AIコメントをOFFにしました"
      );
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 401) {
        toast.info("この設定を変えるにはログインが必要です。");
      } else if (errorCode === 403) {
        toast.info("投稿者だけがAIコメント設定を変えられます。");
      } else {
        toast.error("AIコメント設定の更新に失敗しました。");
      }
    } finally {
      setAiCommentsSaving(false);
    }
  };

  const handleAchieveGoal = async () => {
    if (!isOwner || achievementSaving || goal?.is_achieved) return;
    const report = achievementForm.report.trim();
    const verificationNote = achievementForm.verification_note.trim();
    if (report.length < 5) {
      toast.info("達成報告を5文字以上で書いてください");
      return;
    }

    setAchievementSaving(true);
    try {
      const response = await apiClient.post(
        `${API_BASE_URL}/api/goals/${id}/achieve/`,
        {
          report,
          verification_requested: achievementForm.verification_requested,
          verification_note: verificationNote,
        }
      );
      setGoal((prev) => (
        prev
          ? {
              ...prev,
              is_achieved: response.data.is_achieved,
              achieved_at: response.data.achieved_at,
              achievement_report: response.data.achievement_report,
              achievement_proof_url: response.data.achievement_proof_url,
              achievement_verification_requested: response.data.achievement_verification_requested,
              achievement_verification_note: response.data.achievement_verification_note,
              achievement_verified: response.data.achievement_verified,
              achievement_verified_at: response.data.achievement_verified_at,
            }
          : prev
      ));
      setAchievementForm({ report: "", verification_requested: false, verification_note: "" });
      await fetchBoardAndComments();
      toast.success("達成報告を投稿しました");
    } catch (error) {
      const message = error?.response?.data?.message;
      if (message) {
        toast.error(message);
      } else if (error?.response?.status === 403) {
        toast.info("投稿者だけが達成報告できます");
      } else {
        toast.error("達成報告の保存に失敗しました");
      }
    } finally {
      setAchievementSaving(false);
    }
  };

  // #6 コメントいいね（トグル式＋連打防止2秒クールダウン）
  const handleCancelAchievement = async () => {
    if (!isOwner || achievementSaving || !goal?.is_achieved) return;
    if (!window.confirm("達成報告を取り消しますか？")) return;

    setAchievementSaving(true);
    try {
      const response = await apiClient.post(`${API_BASE_URL}/api/goals/${id}/cancel-achievement/`);
      setGoal((prev) => (
        prev
          ? {
              ...prev,
              is_achieved: response.data.is_achieved,
              achieved_at: response.data.achieved_at,
              achievement_report: response.data.achievement_report,
              achievement_proof_url: response.data.achievement_proof_url,
              achievement_verification_requested: response.data.achievement_verification_requested,
              achievement_verification_note: response.data.achievement_verification_note,
              achievement_verified: response.data.achievement_verified,
              achievement_verified_at: response.data.achievement_verified_at,
            }
          : prev
      ));
      await fetchBoardAndComments();
      toast.success("達成報告を取り消しました");
    } catch (error) {
      const message = error?.response?.data?.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error("達成報告の取り消しに失敗しました");
      }
    } finally {
      setAchievementSaving(false);
    }
  };

  const handleLikeComment = useCallback(async (commentId) => {
    if (likeProcessing.current) return;

    // 連打防止: 前回から2秒以内なら無視
    const now = Date.now();
    const lastTime = likeCooldownRef.current[commentId] || 0;
    if (now - lastTime < 2000) return;

    likeProcessing.current = true;
    likeCooldownRef.current[commentId] = now;

    const currentlyLiked = !!likedCommentIds[commentId];

    try {
      const body = (!isLoggedIn && currentlyLiked) ? { undo: true } : {};
      const likeClient = isLoggedIn ? apiClient : axios;
      const res = await likeClient.post(
        `${API_BASE_URL}/api/boards/${id}/comments/${commentId}/like/`,
        body
      );
      setComments(prev =>
        prev.map(c =>
          c.id === commentId
            ? { ...c, like_count: res.data.like_count, liked_by_me: res.data.liked }
            : c
        )
      );
      setLikedCommentIds(prev => ({ ...prev, [commentId]: res.data.liked }));
    } catch (error) {
      toast.error("いいねに失敗しました。");
    } finally {
      likeProcessing.current = false;
    }
  }, [id, API_BASE_URL, likedCommentIds]);

  // #4 カード画像ダウンロード（showToast=falseで二重表示防止）
  const handleDownloadCard = async (showToast = true) => {
    if (!SHARE_API_URL) return;
    try {
      const response = await fetch(`${SHARE_API_URL}/api/image/${id}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `mubo-card-${id}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      if (showToast) toast.success("カード画像を保存しました！");
    } catch (err) {
      toast.error("画像の保存に失敗しました。");
    }
  };

  // #10 進捗報告投稿
  const handleSubmitProgress = async () => {
    if (!isLoggedIn) {
      toast.info("進捗報告にはログインが必要です。");
      return;
    }
    try {
      await apiClient.post(
        `${API_BASE_URL}/api/goals/${id}/progress/`,
        { goal: id, percentage: newProgress.percentage, note: newProgress.note }
      );
      toast.success("進捗を報告しました！");
      setNewProgress({ percentage: 0, note: "" });
      fetchProgress();
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.info("自分の目標にのみ進捗を報告できます。");
      } else {
        toast.error("進捗の報告に失敗しました。");
      }
    }
  };

  if (unavailable) {
    return (
      <StyledContainer>
        <h2>この夢は現在公開されていません</h2>
        <p>ほかの夢を見たり、あなたの夢を投稿したりできます。</p>
        <Link to="/">夢の一覧へ</Link>
        <Link to="/StartDream">自分の夢を書く</Link>
      </StyledContainer>
    );
  }

  if (!board) {
    return <div>Loading...</div>;
  }

  const handleSupport = async () => {
    if (!isLoggedIn) {
      toast.info("この目標を応援するにはログインしてください。");
      return;
    }
    try {
      await apiClient.post(
        `${API_BASE_URL}/api/goals/${id}/support/`,
        {}
      );
      toast.success("応援ボタンを押しました！");
      fetchGoalAndComments();
    } catch (error) {
      toast.error(
        <>
          応援するにはログインが必要です。
          <br />
          既にログインしている場合は、応援済みの可能性があります。
        </>
      );
    }
  };

  if (!goal) {
    fetchGoalAndComments();
    return <div>読み込み中...</div>;
  }

  const handleNoWay = async () => {
    if (noWayPressed) {
      toast.info("既に押し済みです（リロードするとまた押せます）");
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/goals/${id}/no_way/`);
      toast.success("「できるわけないよ！」を届けました");
      setNoWayPressed(true);
      fetchGoalAndComments();
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  };

  // 目標所有者かどうか
  const isOwner = goal && goal.user && goal.user.id === currentUserID;

  // 最新の進捗率
  const latestProgress = progresses.length > 0 ? progresses[0].percentage : 0;
  const journeySummary = buildCommentAwareJourneySummary({
    goal,
    board,
    progresses,
    comments,
    supportCount,
    noWayCount,
  });
  const nextStepSuggestions = buildNextStepSuggestions({
    progresses,
    comments,
    supportCount,
    noWayCount,
    latestProgress,
  });
  const showCompactJourneySummary = Boolean(goal?.journey_summary);

  return (
    <StyledContainer>
      <h2 style={{ fontSize: 'clamp(1.1rem, 4vw, 1.5rem)', wordBreak: 'break-word', textAlign: 'center', padding: '0 8px' }}>
        {board.title} - 作成者: {board.created_by.username}
      </h2>
      <p style={{ wordBreak: 'break-word', padding: '0 8px' }}>{board.description}</p>
      {isOwner && (
        <OwnerSettingCard>
          <ToggleRow>
            <div>
              <div style={{ fontSize: "13px", fontWeight: "bold", color: "#7a4b00" }}>
                掲示板AIコメント
              </div>
              <div style={{ fontSize: "12px", color: "#8a6b3f", marginTop: "4px", lineHeight: "1.5" }}>
                OFF にすると、その間は初回AIコメント・自動返信・追いコメントが止まります。
              </div>
            </div>
            <ToggleButton
              type="button"
              onClick={handleToggleAiComments}
              disabled={aiCommentsSaving}
              $enabled={board.ai_comments_enabled}
            >
              {aiCommentsSaving ? "更新中..." : board.ai_comments_enabled ? "ON" : "OFF"}
            </ToggleButton>
          </ToggleRow>
        </OwnerSettingCard>
      )}

      <ButtonContainer>
        <SupportStyledButton onClick={handleSupport}>
          目標を
          <br />
          応援する <ReactionCount $tone="support">{supportCount}</ReactionCount>
        </SupportStyledButton>
        <SupportStyledButton
          onClick={handleNoWay}
          disabled={noWayPressed}
          style={noWayPressed ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        >
          {noWayPressed ? '押し済み' : 'できるわけ'}
          <br />
          {noWayPressed ? '' : 'ないよ！'} <ReactionCount $tone="noway">{noWayCount}</ReactionCount>
        </SupportStyledButton>
      </ButtonContainer>
      <p style={{ textAlign: "center", color: "#666", fontSize: "13px", lineHeight: 1.7 }}>
        「できるわけないよ！」を、挑戦の燃料に。<br />
        達成したとき、この票も爽快感に変えよう。
      </p>

      {/* #10 進捗表示 */}
      <ProgressSection style={{ order: 2 }}>
        <h5 style={{ margin: '0 0 8px', fontSize: '14px', fontWeight: 'bold' }}>
          達成進捗: {latestProgress}%
        </h5>
        <ProgressBar>
          <ProgressFill $percent={latestProgress} />
        </ProgressBar>
        {progresses.length > 0 ? (
          <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
            最終報告: {new Date(progresses[0].created_at).toLocaleDateString()} - {progresses[0].note || '(メモなし)'}
          </div>
        ) : (
          <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
            まだ進捗報告がありません
          </div>
        )}
        {isOwner && (
          <>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '8px', marginBottom: '4px' }}>
              スライダーで進捗率を設定して「報告」を押してください
            </div>
            <ProgressInput>
              <input
                type="range"
                min="0"
                max="100"
                value={newProgress.percentage}
                onChange={(e) => setNewProgress({ ...newProgress, percentage: parseInt(e.target.value) })}
                style={{ flex: 1, minWidth: '100px', width: '100%' }}
              />
              <span style={{ fontWeight: 'bold', minWidth: '40px', width: '100%', textAlign: 'center' }}>{newProgress.percentage}%</span>
              <input
                type="text"
                placeholder="メモ（任意）"
                value={newProgress.note}
                onChange={(e) => setNewProgress({ ...newProgress, note: e.target.value })}
                style={{ flex: 2, padding: '4px 8px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '16px', minWidth: '80px', width: '100%', boxSizing: 'border-box' }}
              />
              <button
                onClick={handleSubmitProgress}
                style={{
                  padding: '6px 16px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#667eea',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: '13px',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                報告
              </button>
            </ProgressInput>
          </>
        )}
        {goal?.is_achieved ? (
          <div style={{
            marginTop: "14px",
            padding: "12px",
            borderRadius: "12px",
            background: "#fff7db",
            border: "1px solid #f0d37a",
            fontSize: "13px",
            color: "#624700",
            textAlign: "left",
          }}>
            <strong>達成済み</strong>
            {goal.achieved_at && (
              <div style={{ marginTop: "4px", color: "#7a5a00" }}>
                {new Date(goal.achieved_at).toLocaleDateString()} に達成報告
              </div>
            )}
            {goal.achievement_report && (
              <div style={{ marginTop: "8px", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {goal.achievement_report}
              </div>
            )}
            {goal.achievement_verified ? (
              <div style={{ marginTop: "8px", fontWeight: "bold", color: "#266c2f" }}>
                運営認証済み
              </div>
            ) : goal.achievement_verification_requested ? (
              <div style={{ marginTop: "8px", fontWeight: "bold", color: "#8a5b00" }}>
                運営認証を申請中
              </div>
            ) : (
              <div style={{ marginTop: "8px", color: "#8a5b00" }}>
                自己申告の達成報告です
              </div>
            )}
            {goal.achievement_proof_url && (
              <a
                href={goal.achievement_proof_url}
                target="_blank"
                rel="noreferrer"
                style={{ display: "inline-block", marginTop: "8px", color: "#8a5b00" }}
              >
                証拠URLを見る
              </a>
            )}
            {isOwner && (
              <button
                type="button"
                onClick={handleCancelAchievement}
                disabled={achievementSaving}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  padding: "8px 14px",
                  borderRadius: "999px",
                  border: "1px solid #d8b25d",
                  background: "#fffaf0",
                  color: "#7a4b00",
                  fontWeight: "bold",
                  cursor: achievementSaving ? "not-allowed" : "pointer",
                }}
              >
                {achievementSaving ? "処理中..." : "達成報告を取り消す"}
              </button>
            )}
          </div>
        ) : isOwner ? (
          <div style={{
            marginTop: "14px",
            padding: "12px",
            borderRadius: "12px",
            background: "#fffdf6",
            border: "1px solid #ead9a5",
            textAlign: "left",
          }}>
            <div style={{ fontSize: "13px", fontWeight: "bold", color: "#6b4b00" }}>
              もう達成した？
            </div>
            <div style={{ fontSize: "12px", color: "#7a6a4a", marginTop: "4px" }}>
              達成報告は自己申告です。証拠URLは任意で貼れます。
            </div>
            <textarea
              value={achievementForm.report}
              onChange={(e) => setAchievementForm({ ...achievementForm, report: e.target.value })}
              placeholder="何をもって達成としたかを書いてください"
              rows={3}
              style={{
                width: "100%",
                marginTop: "10px",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #d8c894",
                fontSize: "16px",
                boxSizing: "border-box",
                resize: "vertical",
              }}
            />
            <label style={{
              display: "flex",
              gap: "8px",
              alignItems: "flex-start",
              marginTop: "10px",
              fontSize: "13px",
              color: "#6b4b00",
            }}>
              <input
                type="checkbox"
                checked={achievementForm.verification_requested}
                onChange={(e) => setAchievementForm({
                  ...achievementForm,
                  verification_requested: e.target.checked,
                })}
                style={{ marginTop: "2px" }}
              />
              運営に達成認証を申請する（任意）
            </label>
            {achievementForm.verification_requested && (
              <textarea
                value={achievementForm.verification_note}
                onChange={(e) => setAchievementForm({
                  ...achievementForm,
                  verification_note: e.target.value,
                })}
                placeholder="認証のために運営へ伝えたいことを書いてください。必要なら後で運営から連絡します。"
                rows={3}
                style={{
                  width: "100%",
                  marginTop: "8px",
                  padding: "8px",
                  borderRadius: "8px",
                  border: "1px solid #d8c894",
                  fontSize: "16px",
                  boxSizing: "border-box",
                  resize: "vertical",
                }}
              />
            )}
            <button
              type="button"
              onClick={handleAchieveGoal}
              disabled={achievementSaving}
              style={{
                marginTop: "10px",
                width: "100%",
                padding: "8px 14px",
                borderRadius: "999px",
                border: "none",
                background: achievementSaving ? "#b7a77c" : "#a86f00",
                color: "#fff",
                fontWeight: "bold",
                cursor: achievementSaving ? "not-allowed" : "pointer",
              }}
            >
              {achievementSaving ? "保存中..." : "達成報告を投稿する"}
            </button>
          </div>
        ) : null}
        {nextStepSuggestions.length > 0 && (
          <NextStepCard>
            <NextStepTitle>次の一歩</NextStepTitle>
            <NextStepLead>大きく進めなくても、まずはこの中から1つでOK。</NextStepLead>
            <NextStepList>
              {nextStepSuggestions.map((step) => (
                <NextStepItem key={step}>{step}</NextStepItem>
              ))}
            </NextStepList>
          </NextStepCard>
        )}
        {journeySummary && (
          <JourneySummaryDetails>
            <JourneySummaryToggle>
              <span>ここまでの歩みを見る</span>
              <span style={{ color: "#667085", fontSize: "12px" }}>タップで開く</span>
            </JourneySummaryToggle>
            <JourneySummaryBody>
              <JourneyHeadline>{journeySummary.headline}</JourneyHeadline>
              {!showCompactJourneySummary && (
                <JourneyMeta>
                  {journeySummary.badges.map((badge) => (
                    <JourneyBadge key={badge}>{badge}</JourneyBadge>
                  ))}
                </JourneyMeta>
              )}
              {!showCompactJourneySummary && (
                <JourneyList>
                  {journeySummary.facts.slice(0, 3).map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </JourneyList>
              )}
              <JourneyFooter>{journeySummary.footer}</JourneyFooter>
            </JourneySummaryBody>
          </JourneySummaryDetails>
        )}
      </ProgressSection>

      {/* 無謀度カード画像 & シェアボタン */}
      {(() => {
        const fallbackAnalysis = goal?.ai_score
          ? {
              level: goal.ai_level || 1,
              display_score: `${goal.ai_score}${goal.ai_unit || ""}%`,
              comment: goal.ai_comment || "",
            }
          : null;
        const resolvedAnalysis = aiAnalysis || fallbackAnalysis;
        const level = resolvedAnalysis ? resolvedAnalysis.level : 1;
        const displayScore = resolvedAnalysis ? resolvedAnalysis.display_score : 'AI判定中...';
        const comment = resolvedAnalysis ? resolvedAnalysis.comment : '無謀度を計算中。少し待ってね';

        let shareHeader;
        if (level <= 10) {
          shareHeader = `余裕？ 「${board.title}」の無謀度はたったの${displayScore}...`;
        } else if (level <= 25) {
          shareHeader = `ちょっと無謀 「${board.title}」の無謀度は${displayScore}！`;
        } else if (level <= 45) {
          shareHeader = `相当ヤバい 「${board.title}」の無謀度は${displayScore}！！`;
        } else if (level <= 65) {
          shareHeader = `神話級 「${board.title}」の無謀度は${displayScore}！！！`;
        } else if (level <= 80) {
          shareHeader = `超神話級 「${board.title}」の無謀度は${displayScore}！！！`;
        } else {
          shareHeader = `伝説降臨\n「${board.title}」の無謀度は${displayScore}！！！！`;
        }
        const shareText = `${shareHeader}\nAI判定：『${comment}』\nできるわけないよ！：${noWayCount} / 応援：${supportCount}\n\n#Mubo #無謀な夢 #無謀度${displayScore}`;

        const sharePageUrl = SHARE_API_URL ? `${SHARE_API_URL}/share/${id}` : window.location.href;
        const muboPageUrl = `${window.location.origin}/boards/${id}`;
        const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(sharePageUrl)}`;

        // #8 LINE/Instagramシェア（OGPプレビュー表示のためmubo-share URLを共有）
        const lineMessage = shareText + '\n' + sharePageUrl;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const lineShareUrl = isMobile
          ? `line://msg/text/${encodeURIComponent(lineMessage)}`
          : `https://line.me/R/share?text=${encodeURIComponent(lineMessage)}`;

        const cardImageUrl = SHARE_API_URL ? `${SHARE_API_URL}/api/image/${id}?retry=${cardImageRetryTick}` : null;
        const shouldShowCardImage = Boolean(cardImageUrl && (resolvedAnalysis || aiLoading || !goal?.ai_score));

        return (
          <div style={{ textAlign: 'center', margin: '4px 0 16px', order: 1, width: '100%' }}>
            {/* カード画像を表示 */}
            {shouldShowCardImage ? (
              <CardImageContainer>
                {!cardImageLoaded && showCardImageLoading && (
                  <CardImageSkeleton id={`card-skeleton-${id}`}>
                    <LoadingPulse>
                      {resolvedAnalysis
                        ? "カード画像を読み込み中..."
                        : "AI診断中...\nカードを準備しています"}
                    </LoadingPulse>
                  </CardImageSkeleton>
                )}
                <CardImage
                  src={cardImageUrl}
                  alt={`「${board.title}」の無謀度カード`}
                  loading="lazy"
                  onLoad={(e) => {
                    setCardImageFailed(false);
                    setCardImageLoaded(true);
                    setShowCardImageLoading(false);
                  }}
                  onError={(e) => {
                    const skeleton = document.getElementById(`card-skeleton-${id}`);
                    if (!cardImageLoaded && !goal?.ai_score && cardImageRetryTick < 8) {
                      setCardImageFailed(true);
                      setShowCardImageLoading(true);
                      if (skeleton) skeleton.textContent = 'カードを準備中…もう少し待ってね';
                      window.setTimeout(() => {
                        setAiRefreshTick((prev) => prev + 1);
                        setCardImageRetryTick((prev) => prev + 1);
                      }, 1800);
                      return;
                    }
                    e.target.style.display = 'none';
                    setCardImageFailed(true);
                    if (skeleton) skeleton.textContent = '画像を読み込めませんでした';
                  }}
                />
              </CardImageContainer>
            ) : (
              <div style={{
                padding: '20px',
                margin: '16px auto',
                maxWidth: '500px',
                background: '#f0f0f0',
                borderRadius: '12px',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: '14px', color: '#666', letterSpacing: '3px', marginBottom: '8px' }}>
                  ━ 無 謀 度 ━
                </div>
                <div style={{ fontSize: '36px', fontWeight: '900', color: '#333' }}>
                  {displayScore}
                </div>
              </div>
            )}

            {/* #8 シェアボタン群（X, LINE, Instagram, 画像保存） */}
            <ShareButtonRow>
              <SmallShareButton
                onClick={() => window.open(xShareUrl, '_blank')}
                style={{ background: '#000' }}
              >
                𝕏 シェア
              </SmallShareButton>
              <SmallShareButton
                onClick={() => { window.location.href = lineShareUrl; }}
                style={{ background: '#06c755' }}
              >
                LINE シェア
              </SmallShareButton>
              {/* Instagram共有 */}
              {cardImageUrl && (
                <SmallShareButton
                  onClick={async () => {
                    try {
                      // スマホ: Web Share APIで直接共有
                      if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
                        const res = await fetch(cardImageUrl);
                        const blob = await res.blob();
                        const file = new File([blob], `mubo-card-${id}.png`, { type: 'image/png' });
                        await navigator.share({
                          text: shareText,
                          files: [file],
                        });
                        return;
                      }
                      // PC: 画像保存 + テキストコピー
                      await handleDownloadCard(false);
                      await navigator.clipboard.writeText(shareText + '\n' + sharePageUrl);
                      toast.success("画像保存+テキストコピー済み！Instagramに貼り付けてください");
                    } catch (e) {
                      if (e.name !== 'AbortError') {
                        await handleDownloadCard(false);
                        toast.success("画像を保存しました！Instagramに投稿してください");
                      }
                    }
                  }}
                  style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}
                >
                  Instagram
                </SmallShareButton>
              )}
              {/* #4 画像保存ボタン */}
              {cardImageUrl && (
                <DownloadButton onClick={handleDownloadCard}>
                  画像を保存
                </DownloadButton>
              )}
            </ShareButtonRow>

            {aiAnalysis && (
              <div style={{ fontSize: '10px', opacity: 0.4, marginTop: '8px', color: '#666' }}>
                Powered by AI
              </div>
            )}
          </div>
        );
      })()}

      <h5 style={{ order: 3 }}>- 本サイトの活用方法 -</h5>
      <h5 style={{ order: 3 }}>　目標の進み具合をコメントすることで、前向きな姿勢を保ちながら取り組み続けることができます。　</h5>

      <br style={{ order: 3 }} />

      <StyleLeftAlignedContainer style={{ order: 4 }}>
        <h3>ーコメントー</h3>
        <AiGuideLink to="/AiCommentGuide">AIコメントの件数・仕組みを見る</AiGuideLink>
        <StyledList start={indexOfFirstComment + 1}>
          {currentComments.map((comment) => {
            return (
              <CommentItem key={comment.id} $isOwnerComment={comment.is_owner_comment}>
                <CommentMetaRow>
                  {comment.user_name || "何者でもない小市民"}
                  {comment.is_owner_comment && <OwnerCommentBadge>投稿者</OwnerCommentBadge>}
                  {comment.is_ai_generated && <AiResidentBadge>AI住人</AiResidentBadge>}
                  <span style={{ fontWeight: '400', marginLeft: '8px', color: '#aaa' }}>
                    {new Date(comment.created_at).toLocaleString()}
                  </span>
                </CommentMetaRow>
                <CommentBody $isOwnerComment={comment.is_owner_comment}>
                  {comment.comment_text}
                </CommentBody>
                {/* #6 いいねボタン（トグル式＋連打防止） */}
                <CommentActionRow>
                {(() => {
                  const isLiked = (comment.id in likedCommentIds) ? likedCommentIds[comment.id] : comment.liked_by_me;
                  return (
                    <LikeButton
                      $liked={isLiked}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleLikeComment(comment.id);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={isLiked ? faHeart : faHeartOutline}
                        style={{ marginRight: 4 }}
                      />
                      {comment.like_count || 0}
                    </LikeButton>
                  );
                })()}
                {parseInt(board.created_by.id, 10) === currentUserID && (
                  <DeleteCommentButton type="button" onClick={() => handleDeleteComment(comment.id)}>
                    削除
                  </DeleteCommentButton>
                )}
                </CommentActionRow>
              </CommentItem>
            );
          })}
        </StyledList>
        <div style={{ marginTop: "20px", display: "flex", gap: "5px", alignItems: "center" }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .reduce((acc, page) => {
              const shouldShow =
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 2 && page <= currentPage + 2);

              if (!shouldShow) return acc;

              if (acc.length > 0 && page - acc[acc.length - 1] > 1) {
                acc.push("ellipsis");
              }

              acc.push(page);
              return acc;
            }, [])
            .map((item, index) => {
              if (item === "ellipsis") {
                return (
                  <span key={`ellipsis-${index}`} style={{ padding: "0 5px" }}>
                    ...
                  </span>
                );
              }

              return (
                <button
                  key={item}
                  onClick={() => handlePageChange(item)}
                  style={{
                    width: "32px",
                    height: "32px",
                    fontSize: "12px",
                    backgroundColor: currentPage === item ? "#000000" : "#000000",
                    color: "white",
                    border: "1px solid #000000",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                >
                  {item}
                </button>
              );
            })}

          {currentPage < totalPages && (
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              style={{
                width: "60px",
                height: "32px",
                fontSize: "12px",
                backgroundColor: "#000000",
                color: "white",
                border: "1px solid #000000",
                borderRadius: "4px",
                marginLeft: "8px",
              }}
            >
              次へ
            </button>
          )}
        </div>

        <CommentForm onSubmit={handleCommentSubmit}>
          <StyledTextArea value={newComment} onChange={(e) => setNewComment(e.target.value)} placeholder="コメントを書いてください" required maxLength={500} />
          <PrivacyHint>
            掲示板の文面は、AIコメントの流れ作りに使われることがあります。
            <br />
            メールアドレス・電話番号・住所・URL・SNS ID など、個人情報は書かないでください。
            {commentHasSensitiveInfo && (
              <>
                <br />
                今の入力には個人情報っぽい内容が含まれている可能性があります。
              </>
            )}
          </PrivacyHint>
          <StyledButton type="submit" variant="primary" size="lg" block disabled={commentSubmitting || commentCooldown > 0} className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent", backgroundColor: (commentSubmitting || commentCooldown > 0) ? "#999" : "#6495ed" }}>
            {commentSubmitting ? "投稿中..." : commentCooldown > 0 ? `投稿まで ${commentCooldown}秒` : "コメントを投稿する"}
          </StyledButton>
          <ReturnHint>
            一言置いておくと、あとで空気が変わっていることがあります。
            <br />
            少し時間をおいて戻ると、AIや見物人の反応が増えているかもしれません。
          </ReturnHint>
        </CommentForm>
      </StyleLeftAlignedContainer>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
    </StyledContainer>
  );
}

export default BoardDetailPage;

